import {Typography} from '~library/atoms/Typography';
import {FlipControls} from './FlipControls';
import {RotateControl} from './RotateControl';
import {SizeControl} from './SizeControl';

export const TransformSection = ({canvas, processing}) => (
  <div className="uyo-control-section">
    <Typography variant="label2" className="uyo-control-section-title" color="pebble">
      TRANSFORM
    </Typography>

    <FlipControls canvas={canvas} processing={processing} />

    <SizeControl canvas={canvas} processing={processing} />

    <RotateControl canvas={canvas} processing={processing} />
  </div>
);
